import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';

import Educations from '../../components/Educations';
import Experiences from '../../components/Experiences';
import DownloadPDFButton from '../../components/DownloadPDFButton';
import Skeleton from '../../components/skeleton/Skeleton';

import sectionGreyBg from '../../assets/images/bg_pattern.svg';
import sectionGreenBg from '../../assets/images/section-green.webp';

import { API_ENDPOINTS } from '../../utils/config';

const EducationExperience = () => {
    const [educations, setEducations] = useState([]);  
    const [experiences, setExperiences] = useState([]);
	const [isLoading, setIsLoading] = useState(true); 

	useEffect(() => {
		document.body.classList.add( 'inner-page', 'resume' );
		fetchEducationAndExperienceData();
        	
		return () => {
		  	document.body.classList.remove( 'inner-page', 'resume' );	  	
		}
		// eslint-disable-next-line
	}, []);

    const fetchEducationAndExperienceData = async () => {
		setIsLoading( true );
		const config = {
			headers:{
				'Content-type': 'application/json; charset=UTF-8'
			},
		};

		try{
			const [educationRes, experienceRes] = await Promise.all([
				axios.get(API_ENDPOINTS.EDUCATION_ENDPOINT, config),
				axios.get(API_ENDPOINTS.EXPERIENCES_ENDPOINT, config),
			]);

			setEducations( educationRes.data );
      		setExperiences( experienceRes.data );
		} catch ( error ) {
			console.error( 'Error fetching education or experience data:', error );
		} finally {
            setIsLoading( false );
        }
    };

    return (
		<section
		id="resume"
		className="section"
		style={{ backgroundImage: `url(${sectionGreyBg})` }}
		>
			{/* Top Decorative Background */}
			<div
				className="section-decoration top"
				style={{
				backgroundImage: `url(${sectionGreenBg})`,
				height: '35px',
				}}
			/>

			<Container>
				<Row className="g-5 mt-5">
				{/* Education Column */}
				<Col lg={6} xs={12} className="wow fadeInUp">
					<h2 className="text-6 fw-500 mb-4 pb-2 text-dark">My Education</h2>
					<div className="border-start border-2 border-primary ps-3">
						{ isLoading && <Skeleton type="educations" /> }
						<Educations data={educations} />
					</div>
				</Col>

				{/* Experience Column */}
				<Col lg={6} xs={12} className="wow fadeInUp" data-wow-delay="0.2s">
					<h2 className="text-6 fw-500 mb-4 pb-2 text-dark">My Experience</h2>
					<div className="border-start border-2 border-primary ps-3">
						{ isLoading && <Skeleton type="educations" /> }
						<Experiences data={experiences} />
					</div>
				</Col>
				</Row>

				{/* Resume Download Button */}
				<Row className="mt-5 download_resume">
					<Col
						lg={12}
						xs={12}
						className="wow fadeInUp d-flex justify-content-center"
						data-wow-delay="0.2s"
					>
						<DownloadPDFButton />
					</Col>
				</Row>
			</Container>
		</section>
  	);
};

export default EducationExperience;